import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { NEW_RUN_TYPES } from '@/features/payroll/runs/labels';
import { NewRunPage } from '@/features/payroll/runs/new-run-page';
import { hasAnyPermission } from '@/lib/auth';
import { guardRoute } from '@/lib/route-guards';

const searchSchema = z.object({
  /** Run type to start with (the leavers warning opens a settlement). */
  type: z.enum(NEW_RUN_TYPES).optional().catch(undefined),
  /** Comma-separated employee ids to preselect in a settlement run. */
  employees: z.string().max(10_000).optional().catch(undefined),
});

/** Creating runs needs `payroll.prepare` on top of reading them. */
export const Route = createFileRoute('/_app/payroll_/runs_/new')({
  validateSearch: searchSchema,
  beforeLoad: ({ context }) => {
    guardRoute(context.auth, '/payroll/runs/new');
    if (!hasAnyPermission(context.auth.user, ['payroll.prepare'])) {
      throw redirect({ to: '/payroll/runs' });
    }
  },
  component: NewRunRoute,
});

function NewRunRoute() {
  const { type, employees } = Route.useSearch();
  return (
    <NewRunPage
      initialType={type ?? 'MONTHLY'}
      employeeIds={employees ? employees.split(',').filter(Boolean) : []}
    />
  );
}
